import React, { useState, useRef, useEffect } from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/solid';

const OPTIONS = [
  { value: 'desc', label: 'Date descending', Icon: ArrowDownIcon },
  { value: 'asc', label: 'Date ascending', Icon: ArrowUpIcon },
];

const WorkflowOperationsOrderBy = ({ value = 'desc', onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const current = OPTIONS.find((o) => o.value === value) || OPTIONS[0];
  const CurrentIcon = current.Icon;

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="rounded-lg border border-gray-200 p-1.5 text-gray-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
        title="Order by date"
        aria-label="Order by date"
      >
        <CurrentIcon className="h-4 w-4" />
      </button>
      {open && (
        <div className="absolute right-0 top-full z-20 mt-1 min-w-[180px] rounded-lg border border-gray-200 bg-white py-1 shadow-lg">
          {OPTIONS.map((opt) => {
            const Icon = opt.Icon;
            const isSelected = value === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-50 ${
                  isSelected ? 'bg-green-50 text-green-600' : 'text-gray-700'
                }`}
              >
                <Icon className="h-4 w-4 shrink-0" />
                <span>{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WorkflowOperationsOrderBy;
